import { defineMessages } from 'react-intl';

const messages = defineMessages({
  iframe: {
    id: 'junts_iframe',
    defaultMessage: 'Iframe',
  },
  url: {
    id: 'url',
    defaultMessage: 'Url',
  },
});

export const iframeSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.iframe),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['url'],
      },
    ],

    properties: {
      url: {
        title: props.intl.formatMessage(messages.url),
      },
    },
    required: ['url'],
  };
};
